import { SharedState } from "../SharedProvider";

export const selectIsWebApp = (state: SharedState) => state.appConfigurations.isWebApp;
export const selectIsReadOnly = (state: SharedState) => state.appConfigurations.isReadOnly;
export const selectIsAdvancedModeEnabled = (state: SharedState) => state.appConfigurations.isAdvancedModeEnabled;
export const selectWebappHasUnsyncedChanges = (state: SharedState) => state.appConfigurations.webAppHasUnsyncedChanges;
export const selectCloudHasUnsyncedChanges = (state: SharedState) => state.appConfigurations.cloudHasUnsyncedChanges;
export const selectIsUserAdminOrHigher = (state: SharedState) => state.appConfigurations.isAdminOrHigher;

export const selectDistanceUnit = (state: SharedState) => state.appConfigurations.distanceUnit;